import React, { memo } from 'react';
import { Form } from 'react-final-form';

import { trackingContext } from '@swf/core/models/sports/betSlip/config';
import { SportsComponent } from '@swf/sports/components/SportsComponent/SportsComponent';

import BetSlip from './components/BetSlip/BetSlip';
import useParseStakesDecorator from './hooks/useParseStakesDecorator';
import usePersistBetSlip from './hooks/usePersistBetSlip';
import usePlaceBet from './hooks/usePlaceBet';
import type { FormData } from './types';
import { betSlipMutators } from './utils/betSlipFormMutators';

const BetSlipForm = memo(() => {
  const placeBet = usePlaceBet();
  const parseStakes = useParseStakesDecorator();
  usePersistBetSlip();

  return (
    <Form<FormData>
      decorators={[parseStakes]}
      initialValues={{}}
      onSubmit={placeBet}
      mutators={betSlipMutators}
      subscription={{ submitSucceeded: true }}
      render={(formRenderProps) => <BetSlip {...formRenderProps} />}
    />
  );
});

const BetSlipWrapper = () => (
  <SportsComponent
    widgetContext={trackingContext.widget.widgetContext}
    name={trackingContext.widget.widgetName}
    testId={trackingContext.widget.widgetId}
    asChild
  >
    <BetSlipForm />
  </SportsComponent>
);

export default BetSlipWrapper;
